import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Card } from "../../../elements/Card";
import { styles } from "./SkeletonReportCard.style";

export interface SkeletonReportCardProps {
  displayShortCard?: boolean;
}

export const SkeletonReportCard = (props: SkeletonReportCardProps) => {
  const { displayShortCard = false } = props;
  return (
    <>
      {displayShortCard ? (
        <Card className={styles.card()}>
          <div className={styles.floatingRisk()}>
            <Skeleton height={18} width={110} borderRadius={"4px 0 0 4px"} />
          </div>
          <div className={styles.shortCardWrapper()}>
            <div className={styles.mobileRow()}>
              <Skeleton height={16} width={100} />
              <Skeleton height={20} width={175} />
            </div>
            <div className={styles.mobileRow()}>
              <Skeleton height={16} width={75} />
              <Skeleton height={20} width={175} />
            </div>
            <div className={styles.purchasedRow()}>
              <Skeleton height={16} width={120} />
              <Skeleton height={20} width={150} />
            </div>
          </div>
          <div className={styles.footer()}>
            <Skeleton height={20} width={65} />
          </div>
        </Card>
      ) : (
        <Card className={styles.card()}>
          <div className={styles.floatingRisk()}>
            <Skeleton height={18} width={50} borderRadius={"4px 0 0 4px"} />
          </div>
          <div className={styles.wrapper()}>
            <Skeleton height={16} width={120} />
            <Skeleton height={20} width={210} />
          </div>
          <div className={styles.wrapper()}>
            <Skeleton height={16} width={40} />
            <Skeleton height={20} width={180} />
          </div>
          <div className={styles.wrapper()}>
            <Skeleton height={16} width={60} />
            <Skeleton height={20} width={120} />
          </div>
          <div className={styles.wrapper()}>
            <Skeleton height={16} width={75} />
            <Skeleton height={20} width={100} />
          </div>
          <div className={styles.footer()}>
            <Skeleton height={20} width={65} />
          </div>
        </Card>
      )}
    </>
  );
};
